import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaHome, FaUsers, FaUserPlus, FaUserFriends, FaBookOpen, FaChalkboardTeacher, FaDollarSign
} from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';
import { canAccessPage } from '../../utils/permissions';

// --- 이 부분이 누락되었습니다! ---
// 메뉴 아이템의 타입을 먼저 정의합니다.
type NavItem = {
  to: string;
  icon: React.ReactElement;
  label: string;
  page?: string;
};

interface SidebarProps {
  isSidebarOpen: boolean;
  setSidebarOpen: (isOpen: boolean) => void;
}

// 사이드바에 표시될 메뉴 데이터를 배열로 정의합니다.
const navItems: NavItem[] = [
  { to: "/", icon: <FaHome />, label: "온라인처치", page: "dashboard" },
  { to: "/members", icon: <FaUsers />, label: "성도관리", page: "members" },
  { to: "/newcomers", icon: <FaUserPlus />, label: "새가족관리", page: "newcomers" },
  { to: "/visitors", icon: <FaUserFriends />, label: "방문자관리", page: "visitors" },
  { to: "/visitations", icon: <FaBookOpen />, label: "심방관리", page: "visitations" },
  { to: "/discipleship", icon: <FaChalkboardTeacher />, label: "양육관리", page: "discipleship" },
  { to: "/finance", icon: <FaDollarSign />, label: "재정관리", page: "finance" },
];
// --- 여기까지 누락된 부분이었습니다. ---

export const Sidebar: React.FC<SidebarProps> = ({ isSidebarOpen, setSidebarOpen }) => {
  const { user } = useAuth();
  const activeLinkClass = "bg-[#31572c] text-white dark:bg-gray-700";
  const inactiveLinkClass = "text-white hover:bg-[#b0c4b1] hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";

  // 접근 가능한 메뉴만 필터링
  const accessibleNavItems = navItems.filter(item => {
    if (!item.page) return true; // 페이지 정의가 없으면 모든 사용자에게 표시
    return canAccessPage(user, item.page);
  });

  return (
    <>
      <aside
        className={`fixed inset-y-0 left-0 z-30 flex flex-col w-64 h-screen px-4 py-8 bg-[#4f772d] dark:bg-gray-800 border-r dark:border-gray-700 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      >
        <div className="flex items-center px-2 mb-10">
          <img src="/symbol.png" alt="교회 심볼" className="w-10 h-10" />
          <h1 className="ml-3 text-xl font-medium text-white dark:text-gray-200">온라인행정</h1>
        </div>

        <nav className="flex-1 flex flex-col gap-y-2">
          {accessibleNavItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              onClick={() => setSidebarOpen(false)} // Close sidebar on link click
              className={({ isActive }) => `${isActive ? activeLinkClass : inactiveLinkClass} group flex items-center px-4 py-2 rounded-md transition-colors duration-200`}
            >
              {item.icon}
              <span className="mx-4 font-normal">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black opacity-50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </>
  );
};
